<template>
  <div class="app-notification" v-observe-visibility="visibilityChanged"><!---->
    <div class="app-notification__body"><!---->
      <div class="app-notification__line" :style="{backgroundColor:groups[typeGroup].color}"></div>
      <div class="app-notification__closeBtn" @click="deleteNotification"><img src="static/img/close-gray.svg"/></div>
      <div class="app-notification__group">
        <div class="app-notification__heading">
          <div class="app-notification__heading--type">{{groups[typeGroup].name}}</div>
          <div class="app-notification__heading--date">{{notification.getDate().format('HH:mm')}}</div>
        </div>
        <div class="app-notification__title">{{notification.makeText().title}}</div>
        <div class="app-notification__content">{{notification.makeText().description}}</div>
        <!---->
      </div>
    </div>
  </div>
</template>

<script>
  /**
   * @vue-prop {Notification} notification
   */
  export default {
    name: 'Notification',
    props: ['notification', 'day'],
    data () {
      return {
        groups: {
          'user': {name: this.$t('labels.employee'), color: '#FF3738'}
        }
      }
    },
    methods: {
      visibilityChanged (ev) {
        let listVisible = this.$store.state.notifications.panelExpanded || this.$route.name === 'notificationsListPage';
        if (listVisible && ev && this.notification.isUnread() && listVisible) {
          this.notification.markRead()
        }
      },
      deleteNotification () {
        this.notification.delete()
      }
    },
    computed: {
      typeGroup () {
        if (!this.notification.getType()) {
          return 'user'
        }
        return this.notification.getType().split('_')[0]
      }
    }
  }
</script>

<style lang="scss">
  @import 'src/assets/sass/paper/variables';

  .app-notification {
    position: relative;
    width: auto;
    padding-top: 10px;
    border-radius: 3px;
    display: block;
    overflow: visible;
    &__body {
      box-shadow: 0px 5px 25px rgba(0, 0, 0, 0.05);
    }
    &__line {
      position: absolute;
      left: 0;
      top: 10px;
      height: 8px;
      width: 8px;
      border-bottom-right-radius: 8px;
      border-top-left-radius: 3px;
    }
    &__group {
      margin: 0;
      padding: 15px 20px;
    }
    &__heading {
      display: flex;
      justify-content: space-between;
      font-size: 12px;
      padding-bottom: 10px;
      color: #909399;
      &--date {
        font-size: 12px;
      }
    }
    &__title {
      font-size: 14px;
      color: #000000;
      padding-bottom: 3px;
    }
    &__content {
      font-size: 12px;
      color: #909399;
    }
    &__closeBtn {
      cursor: pointer;
      position: absolute;
      width: 34px;
      height: 34px;
      padding: 10px;
      line-height: 14px;
      top: -7px;
      right: -17px;
      @media (min-width: $screen-md) {
        display: none;
      }
    }
    &:hover {
      .app-notification__title {
        /* color: #1E5A9F;*/
      }
      .app-notification__closeBtn {
        display: block;
      }
    }
  }
</style>